import ProductDescription from './ProductDescription'

const BSWholeWheatPitaBreadProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '012BS',
  IsBroadband: true,
  Size: '',
}

export default BSWholeWheatPitaBreadProduct
